import React from "react";
import styles from "./ADSButton.module.scss";

const ADSButton = ({ children, disabled, className, onClick, ...props }) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick?.();
  };

  return (
    <div
      className={`${styles.wrapper} ${disabled ? styles.disabled : ""} ${
        className || ""
      }`}
      onClick={handleClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default ADSButton;
